import script from "./FormBenefit.vue?vue&type=script&setup=true&lang=js"
export * from "./FormBenefit.vue?vue&type=script&setup=true&lang=js"

import "./FormBenefit.vue?vue&type=style&index=0&id=8d8b0004&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d8b0004"]])

export default __exports__